import { useCreateOpportunity } from "@api/opportunityService";
import OpportunityEdit from "./OpportunityEdit";

export default function OpportunityCreate() {
    return <OpportunityEdit
        mutation={useCreateOpportunity}
        title={'New Opportunity'}
        create
    />
}
